import React from 'react';
import { IPropertyAddressData } from 'types/address/IPropertyAddressData';

export type TAddressDisplay = Pick<
  IPropertyAddressData,
  'streetAddress' | 'city' | 'stateAbbreviation' | 'unit' | 'zipCode'
>;

export const AddressDisplay = ({ streetAddress, city, stateAbbreviation, unit, zipCode }: TAddressDisplay) => (
  <>
    {streetAddress}
    {unit ? ` ${unit}` : ''} {city}
    <br />
    {stateAbbreviation} {zipCode}
  </>
);
